export default {
  orders: 'Orders',
  allOrders: 'All orders',
  onlyInJobReports: 'Parts are only listed in reports of a single job.',
};
